import React from 'react';
import { ReactComponent as FelicitationsImage } from 'assets/images/felicitations-image.svg';
import { Trans, useTranslation } from 'react-i18next';
import SendEmailToSeller from 'applications/automotor/components/espace-automotor/send-email-to-seller/SendEmailToSeller';
import { useSelector } from 'react-redux';
import { getAutomotorTariff } from 'store/selectors/automotor-tariff.selector';
import { useLocation } from 'react-router-dom';
import './Felicitations.scss';

type Seller = {
  name: string;
};


const Felicitations: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const data = useSelector(getAutomotorTariff) as Seller[];

  return (
    <div className="menu-automotor-felicitations">


      <div className="menu-automotor-felicitations-message">

        <div className="felicitations-title">{t('_felicitations_title')}</div>
        <div className="felicitations-image">
          <FelicitationsImage />
        </div>
        <div className="felicitations-text">
          {(location.state as { showMessageType: string })?.showMessageType === 'MAPPING_DOES_NOT_EXIST' ?
            <Trans i18nKey="_felicitations_message" components={{ br: <br />, span: <span /> }} /> :
            <div dangerouslySetInnerHTML={{ __html: t('_upload_invalid_file_message', { name_seller: data?.[0]?.name || '' }) }} />}
        </div>
      </div>
      <div className="question-container">
        <SendEmailToSeller />
      </div>
    </div >
  );
};

export default Felicitations;
